import { reactive } from "vue";
import ResearchCategoryRepositoryAPI from "./research-category-repository-api";

interface MultiViewCategory {
  id: string;
  nameSlovene: string;
  nameEnglish: string;
  number: number;
  children?: MultiViewCategory[];
}

const threeLayeredCategoryDisplayData = (item: any): MultiViewCategory => {
  return {
    id: item.id,
    nameSlovene: item.nameSlovene,
    nameEnglish: item.nameEnglish,
    number: item.number,
    children: item.equipmentUniLeedOrderTypes.map((item: any) => {
      return {
        id: item.id,
        nameSlovene: item.nameSlovene,
        nameEnglish: item.nameEnglish,
        number: item.number,
        children: item.equipmentUniLeedTypes.map((item: any) => {
          return {
            id: item.id,
            nameSlovene: item.nameSlovene,
            nameEnglish: item.nameEnglish,
            number: item.number,
          };
        }),
      } as MultiViewCategory;
    }),
  } as MultiViewCategory;
};

export default function ResearchCategorySelectionData() {
  const state = reactive({
    equipmentResearchOrientationTypes: [],
    equipmentCriterion: [],

    uniLeedClassTypes: [],
    uniLeedOrderTypes: [],
    uniLeedTypes: [],

    accessPurposes: [],
    accessTypes: [],
    lifeStatusCodes: [],
    accessMethods: [],
    cities: [],

    targetGroup: [],
    equipmentFundingTypes: [],
    researchGroup: [],
    userRoles: [],
  });

  async function loadEquipmentCategories(): Promise<void> {
    const { loadCategories } = ResearchCategoryRepositoryAPI();
    const categories = await loadCategories();
    setResearchInfrastructureCategories(categories);
  }

  async function loadEquipmentTargetGroup(): Promise<void> {
    const { loadTargetGroups } = ResearchCategoryRepositoryAPI();
    const targetGroup = await loadTargetGroups();
    state.targetGroup = targetGroup;
  }

  const setResearchInfrastructureCategories = (data: any): void => {
    state.accessPurposes = data.accessPurposes;
    state.accessTypes = data.accessTypes;
    state.lifeStatusCodes = data.lifeStatusCodes;
    state.accessMethods = data.accessMethods;
    state.cities = data.cities;

    state.equipmentResearchOrientationTypes =
      data.equipmentResearchOrientationTypes;
    state.equipmentCriterion = data.equipmentCriterion;
    state.uniLeedClassTypes = data.uniLeedClassTypes;
    state.uniLeedClassTypes = data.uniLeedClassTypes.map((item: any) =>
      threeLayeredCategoryDisplayData(item.equipmentUniLeedClassType)
    );
    state.equipmentFundingTypes = data.equipmentFundingTypes;
    state.researchGroup = data.researchGroup;
    state.userRoles = data.userRoles;
  };

  return {
    getResearchCategories: state,
    loadEquipmentCategories: loadEquipmentCategories,
    loadEquipmentTargetGroup,
  };
}
